import { useEffect, useState, useCallback } from "react";
import { getStorageItem, updateStorageItem } from "../helpers/storageUtils";

const BOATER_STORAGE_KEY = "boaterProcess";
const BOATER_STORAGE_CHANGE_EVENT = "boaterStorageChange";

export function useBoaterStorage() {
    const getParsedStorage = useCallback(
        () => getStorageItem(BOATER_STORAGE_KEY, {}),
        [],
    );

    const [boaterStorage, setBoaterStorage] = useState(getParsedStorage());

    const dispatchCustomEvent = (oldValue, newValue) => {
        const event = new CustomEvent(BOATER_STORAGE_CHANGE_EVENT, {
            detail: {
                key: BOATER_STORAGE_KEY,
                oldValue: JSON.stringify(oldValue),
                newValue: JSON.stringify(newValue),
            },
        });
        window.dispatchEvent(event);
    };

    const clearBoaterStorage = () => {
        updateBoaterStorage({});
        dispatchCustomEvent(boaterStorage, {});
    };

    const updateBoaterStorage = (object) => {
        const newStorage = {
            ...boaterStorage,
            ...object,
        };

        updateStorageItem(BOATER_STORAGE_KEY, newStorage);
        dispatchCustomEvent(boaterStorage, newStorage);
    };

    useEffect(() => {
        const handleBoaterStorageChange = (e) => {
            if (e.detail?.key !== BOATER_STORAGE_KEY) return;

            const newStorage = JSON.parse(e.detail.newValue);
            setBoaterStorage(newStorage);
        };

        window.addEventListener(
            BOATER_STORAGE_CHANGE_EVENT,
            handleBoaterStorageChange,
        );

        return () => {
            window.removeEventListener(
                BOATER_STORAGE_CHANGE_EVENT,
                handleBoaterStorageChange,
            );
        };
    }, []);

    return {
        boaterStorage,
        clearBoaterStorage,
        updateBoaterStorage,
    };
}

export function withBoaterStorage(Component) {
    return function WrappedComponent(props) {
        const boaterStorageProps = useBoaterStorage();
        return <Component {...props} {...boaterStorageProps} />;
    };
}
